// BaseAiSettingsService.js

import { httpsCallable } from 'firebase/functions';

import { functions } from 'firebaseConfig';

export async function getBaseAiSettings(baseId) {
  const fn = httpsCallable(functions, 'getBaseAiSettings');
  const cleaned = String(baseId || '').trim();
  const { data } = await fn({
    baseId: cleaned,
    baseKey: cleaned,
  });
  return data || null;
}

export async function updateBaseAiSettings({
  baseId,
  defaultPrimaryProfileId,
} = {}) {
  const fn = httpsCallable(functions, 'updateBaseAiSettings');
  const cleaned = String(baseId || '').trim();
  const payload = {
    baseId: cleaned,
    baseKey: cleaned,
  };
  if (defaultPrimaryProfileId !== undefined) {
    payload.defaultPrimaryProfileId = defaultPrimaryProfileId;
  }
  const { data } = await fn(payload);
  return data || null;
}
